import React, { Component } from "react";
import VideoMain from "../../Common/VideoMain/VideoMain";

class LearningVideos extends Component {
  render() {
    return <VideoMain {...this.props} isWorkflow={false} showError={this.props.showError} />;
  }
}

export default LearningVideos;



// WEBPACK FOOTER //
// ./src/containers/User/Learning/LearningVideos/LearningVideos.js